import { NoddiMultiSelect, NoddiMultiSelectProps } from '@ui-components/Inputs/NoddiMultiSelect/NoddiMultiSelect';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<NoddiMultiSelectProps, 'onChange' | 'value'> & {
  onSelectionSideEffect?: (values: (string | number)[]) => void;
};

export const TanstackFormMultiSelect = ({ onSelectionSideEffect, ...rest }: Props) => {
  const field = useFieldContext<(string | number)[]>();
  const fieldAria = useTanstackFieldAria(field, rest['aria-describedby']);

  return (
    <div>
      <NoddiMultiSelect
        {...rest}
        id={rest.id ?? field.name}
        name={field.name}
        {...fieldAria}
        defaultValue={field.state.value}
        onChange={(values) => {
          field.handleChange(values);
          onSelectionSideEffect?.(values);
        }}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
